export default {"src":"/_next/static/media/icon-leave.049374b8.svg","height":16,"width":16};